<ng-container *ngIf="state$ | async as state">
  <button
    *ngIf="state.items.length > 0 && !isDockedToUserMenu"
    #bellButton
    type="button"
    class="fs-notifications-bell"
    [class.fs-notifications-bell--read]="state.unreadCount === 0"
    [class.isDragging]="isDragging"
    (mousedown)="startDrag($event)"
    (click)="handleBellClick($event)"
    (dblclick)="handleBellDoubleClick($event)"
    title="Zobrazit nepřečtené notifikace"
  >
    <fa-icon [icon]="faBell"></fa-icon>
    <span class="fs-notifications-bell__badge" *ngIf="state.unreadCount > 0">{{ state.unreadCount }}</span>
  </button>

  <section
    *ngIf="state.panelOpen"
    #panelRoot
    class="fs-notifications-panel"
    [class.fs-notifications-panel--menu-anchor]="state.panelAnchor === 'menu'"
  >
    <header class="fs-notifications-panel__header">
      <div>
        <strong>Notifikace</strong>
        <small *ngIf="state.unreadCount > 0">{{ state.unreadCount }} nepřečtených</small>
      </div>
      <div class="fs-notifications-panel__actions">
        <button type="button" *ngIf="state.unreadCount > 0" (click)="markAllAsRead()" title="Označit vše jako přečtené">
          <fa-icon [icon]="faCheckDouble"></fa-icon>
        </button>
        <button type="button" (click)="closePanel()" title="Zavřít panel">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
    </header>

    <div class="fs-notifications-panel__loading" *ngIf="state.loading">Načítání…</div>

    <div class="fs-notifications-panel__empty" *ngIf="!state.loading && !state.items.length">Nemáte žádné notifikace.</div>

    <div class="fs-notifications-list" *ngIf="state.items.length">
      <article
        *ngFor="let item of state.items; trackBy: trackById"
        class="fs-notification-item"
        [class.fs-notification-item--unread]="!item.readAt"
      >
        <div class="fs-notification-item__body">
          <button type="button" class="fs-notification-item__title" (click)="openLink(item)" [disabled]="!item.link">
            {{ item.title }}
          </button>
          <p>{{ item.message }}</p>
          <div class="fs-notification-item__meta" *ngIf="getProductLabel(item) || getSupplierLabel(item)">
            <div *ngIf="getProductLabel(item)"><strong>Produkt:</strong> {{ getProductLabel(item) }}</div>
            <div *ngIf="getSupplierLabel(item)"><strong>Dodavatel:</strong> {{ getSupplierLabel(item) }}</div>
          </div>
          <div class="fs-notification-item__media-actions" *ngIf="getImageUrl(item)">
            <button type="button" (click)="openImage(item)">Otevřít obrázek</button>
            <button type="button" (click)="downloadImage(item)">Stáhnout</button>
          </div>
          <small *ngIf="item.createdAt">{{ item.createdAt | date : 'd.M.y H:mm' }}</small>
        </div>
        <button
          *ngIf="!item.readAt"
          type="button"
          class="fs-notification-item__close"
          (click)="markAsRead(item)"
          title="Uzavřít notifikaci"
        >
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </article>
    </div>
  </section>
</ng-container>
